<ng-container *ngIf="isBrowser">
    <ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title}}</span>
        <ng-container *ngTemplateOutlet="airports?.length > 0  ? aslist : fromextern"></ng-container>
    </div>
</ng-template>


<ng-template #fromextern>
    <div class="tmp-section-body">
        <button class="tmp-f-selection-btn" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
            (click)="openModalMobile($event)" matRipple>
            <div class="tmp-btn-sub">
                <mat-icon class="tmp-f-selection-btn-icon rotate mr05" style="color:var(--coralgrey)">flight</mat-icon>
                <span multilang>{{zielText}}</span>
            </div>
            <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
        </button>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>



<ng-template #homemodeMobile>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title}}</span>
        <ng-container *ngTemplateOutlet="airports?.length > 0  ? aslist : fromextern"></ng-container>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title}}</span>
        <div class="tmp-section-body">
            <button class="tmp-f-selection-btn" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
                (click)="openModal($event)" matRipple>
                <div class="tmp-btn-sub">
                    <mat-icon class="tmp-f-selection-btn-icon rotate mr05"
                        style="color:var(--coralgrey)">flight</mat-icon>
                    <span multilang>{{zielText}}</span>
                </div>
                <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
            </button>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="Flughafen hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="sendSelect()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="Flughafen hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <ng-container *ngIf="selectedList?.length > 0">
            <div class="selected-wrapper">
                <button class="selected-item-alle" (click)="removeAllSelected()">
                    <span multilang>Alles löschen</span>
                </button>
                <ng-container *ngFor="let item of selectedList; let k = index">
                    <div class="selected-item">
                        <span multilang>{{item.name}} <span multilang
                                class="second-item-line">{{item.code}}</span></span>
                        <button (click)="removeFromSelected(k)">
                            <mat-icon class="clearbtn">clear</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngFor="let item of (searchObj | async)">
            <ng-container *ngIf="isNotInlist(item)">
                <button class="item-wrapper" (click)="selectValue(item)">
                    <div class="item-body">
                        <span multilang class="first-item-line">{{item.name}} <span
                                class="second-item-line">{{item.code}}</span></span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="sendSelect()">ÜBERNEHMEN</button>
    </div>
</ng-template>


<ng-template #aslist>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of sortArray(airports)| slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selected(item)" matRipple>
                <div style="display: flex;align-items: center;">
                    @if(selectedListOnlyCode.indexOf(item.code) >= 0){
                    <img src="../../../../../assets/icons/tickedcheckbox.png" alt="">
                    }@else{
                    <img src="../../../../../assets/icons/checkbox.png" alt=""> }
                </div>
                <div class="bestprc">
                    <span multilang class="tour-item-name">{{item.name}}</span>
                    <span multilang class="bestprcit">ab {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="airports.length > 5">
            <ng-container *ngIf="(slicenbr < airports.length) else less">
                <button class="showallbtn" (click)="showMore(airports.length)" matRipple>
                    <span multilang>alle {{airports.length}} anzeigen</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>weniger anzeigen</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>